// OAuth callback 라우트 경로다. Router와 redirect_uri 계산이 같은 값을 쓴다.
export const authCallbackPath = "/auth/callback";

// 현재 환경(로컬·dev 등)의 콜백 URL을 만든다. 백엔드 /start는 이 값을 허용목록
// (GITHUB_ALLOWED_REDIRECT_URIS)과 대조한다. 그 뒤 값을 authorize_url에 포함하고 token 교환에
// 다시 쓴다. GitHub App 하나로 환경별 콜백을 처리하려면 프론트가 자기 origin을 명시해야 한다.
export function resolveGithubRedirectUri(): string {
  return `${window.location.origin}${authCallbackPath}`;
}
